const images = {
  success_stories: {
    one: require("./success-story/one.png"),
    two: require("./success-story/two.png"),
    three: require("./success-story/three.png"),
    four: require("./success-story/four.png"),
    five: require("./success-story/five.png"),
    six: require("./success-story/six.png"),
    seven: require("./success-story/seven.png"),
    eigth: require("./success-story/eigth.png"),
    nine: require("./success-story/nine.png"),
    profile: require("./success-story/manager.png"),
  },
  business: {
    one: require("./business/business-two.png"),
    two: require("./business/business-one.png"),
  },
  create_course: {
    one: require("./create-course/one.png"),
    two: require("./create-course/two.png"),
    three: require("./create-course/three.png"),
    four: require("./create-course/four.png"),
    lauch: require("./create-course/launch_your_identity.png"),
    cocreate: require("./create-course/lets_co_create.png"),
    course_placeholder: require("./course-placeholder.png"),
    female_helper: require("./create-course/female_help.png"),
    male_space: require("./create-course/male._this_is_your_space.png"),
    course_structure_1: require("./create-course/course_structure_1.png"),
    course_structure_2: require("./create-course/course_structure_2.png"),
    course_structure_3: require("./create-course/course_structure_3.png"),
    course_structure_4: require("./create-course/course_structure_4.png"),
    course_structure_5: require("./create-course/course_structure_5.png"),
    setup_test_video_1: require("./create-course/setup_test_video_1.png"),
    setup_test_video_2: require("./create-course/setup_test_video_2.png"),
    setup_test_video_3: require("./create-course/setup_test_video_3.png"),
    setup_test_video_4: require("./create-course/setup_test_video_4.png"),
    setup_test_video_5: require("./create-course/setup_test_video_5.png"),
    film_edit_1: require("./create-course/film_edit_1.png"),
    film_edit_2: require("./create-course/film_edit_2.png"),
    film_edit_3: require("./create-course/film_edit_3.png"),
    film_edit_4: require("./create-course/film_edit_4.png"),
    film_edit_5: require("./create-course/film_edit_5.png"),
  },
  home: {
    blur: require("./blur.png"),
    banner: require("./banner.png"),
    success_story: require("./home/home-ss.png"),
    preview_course: require("./home/preview-course.png"),
    animation: require("./home/home_interaction.json"),
    cart: require("./shopping-bag.png"),
    template_default: require("./templates_thumbnails.jpg"),
  },
  profile: {
    placeholder: require("./dummy-profile.png"),
  },
  modal: {
    login: require("./modals/login.png"),
    checkout: require("./modals/checkout.png"),
    course_purchased: require("./modals/course_add_2.png"),
    no_notification: require("./modals/no_notification.png"),
    aiChatHeader: require("./chat_header.png"),
    check : require("./check.png")
  },
  dummy: {
    course: require("./course-dummy.jpg"),
  },
  about_us: {
    one: require("./about-us/1.png"),
    two: require("./about-us/2.png"),
    three: require("./about-us/3.png"),
    four: require("./about-us/4.png"),
    five: require("./about-us/5.png"),
    six: require("./about-us/6.png"),
    seven: require("./about-us/7.png"),
    eigth: require("./about-us/8.png"),
    nine: require("./about-us/9.png"),
  },
  calculator: {
    bfp: require("./calculators/bfp.png"),
    bmi: require("./calculators/bmi.png"),
    macro: require("./calculators/macro.png"),
    bmigraph: require("./calculators/bmi-graph.png"),
    bmr: require("./calculators/bmr.png"),
    heartRate: require("./calculators/Heart-Rate.png"),
    idealBodyWeight: require("./calculators/Ideal-Body-Weight.png"),
    waistToHip: require("./calculators/Waist-to-Hip.png"),
    hydration: require("./calculators/Hydration.png"),
    oneRepMax: require("./calculators/One-Rep-Max.png"),
    sleep: require("./calculators/sleep.png"),
  },
  fitness_test: {
    cardio: require("./fitness-test/cardio.png"),
    strength: require("./fitness-test/strength.png"),
    flexibility: require("./fitness-test/flexibility.png"),
    balance: require("./fitness-test/balance.png"),
  },
  key_feature: {
    one: require("./feature-icon-1.png"),
    two: require("./feature-icon-2.png"),
    three: require("./feature-icon-3.png"),
    four: require("./feature-icon-4.png"),
    five: require("./feature-icon-5.png"),
    six: require("./feature-icon-6.png"),
    feature_left: require("./features-left.png"),
    feature_right: require("./features-right.png"),
  },
  error: {
    error: require("./error.png"),
  },
};

export default images;
